import { appManager, AppState } from '../manager';
import type { LsegEodQuotaSnapshot } from './types';

// A slower initial read or refresh must not overwrite a newer socket update.
const acceptSnapshot = (state: AppState, snapshot: LsegEodQuotaSnapshot) => {
  const current = state.lseg_eod_quota.snapshot;
  if (
    current?.attempted_at &&
    (!snapshot.attempted_at ||
      Date.parse(current.attempted_at) > Date.parse(snapshot.attempted_at))
  ) {
    return;
  }
  state.lseg_eod_quota.snapshot = snapshot;
  state.lseg_eod_quota.error = undefined;
};

export const fetchLsegEodQuota = appManager.createApi<
  Record<string, never>,
  LsegEodQuotaSnapshot,
  AppState
>('FETCH_LSEG_EOD_QUOTA', {
  path: '/admin/lseg_eod_quota',
  method: 'GET',
  startReducer(state) {
    state.lseg_eod_quota.loading = true;
    state.lseg_eod_quota.error = undefined;
  },
  successReducer(state, snapshot) {
    state.lseg_eod_quota.loading = false;
    acceptSnapshot(state, snapshot);
  },
  failReducer(state) {
    state.lseg_eod_quota.loading = false;
    state.lseg_eod_quota.error = 'Could not load the saved LSEG quota.';
  },
});

export const refreshLsegEodQuota = appManager.createApi<
  Record<string, never>,
  LsegEodQuotaSnapshot,
  AppState
>('REFRESH_LSEG_EOD_QUOTA', {
  path: '/admin/refresh_lseg_eod_quota',
  method: 'POST',
  startReducer(state) {
    state.lseg_eod_quota.refreshing = true;
    state.lseg_eod_quota.error = undefined;
  },
  successReducer(state, snapshot) {
    state.lseg_eod_quota.refreshing = false;
    acceptSnapshot(state, snapshot);
  },
  failReducer(state, error) {
    state.lseg_eod_quota.refreshing = false;
    const snapshot = (error as unknown as { quota?: LsegEodQuotaSnapshot })
      ?.quota;
    if (snapshot) {
      acceptSnapshot(state, snapshot);
    } else {
      state.lseg_eod_quota.error =
        'Could not refresh LSEG quota. Showing the last saved value.';
    }
  },
});

appManager.createSocketListener<LsegEodQuotaSnapshot, AppState>(
  'lseg_eod_quota_updated',
  acceptSnapshot,
);
